<template>
  <div class="wrapper">
    <img src="@/assets/coin-list-header.svg" class="image" alt="tokens" />
    <h3 class="title">{{ $t('dialogs.howToListToken') }}</h3>
    <p class="description" v-html="$t('dialogs.howToListTokenDescription')" />
    <a
      class="p-button p-component p-button-primary list-button"
      href="https://form.typeform.com/to/zldvAGqj"
      target="_blank"
      rel="noreferrer noopenner"
      @click="handleClick"
    >
      {{ $t('dialogs.listYourToken') }}
    </a>
  </div>
</template>

<script lang="ts" setup>
import { inject } from 'vue';

const dialogRef = inject('dialogRef');

const handleClick = () => {
  dialogRef.value.close();
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .title {
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: 0.15px;
    text-align: left;
    margin: 24px 0 16px;
  }

  .description {
    font-family: Roboto;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.4399999976158142px;
    text-align: center;
    margin: 0 0 24px;
  }

  .list-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.25s;
  }
}
</style>
<style lang="scss">
.coin-list-dialog .p-dialog-header {
  display: flex !important;
  justify-content: flex-end !important;
}
</style>
